import _, { last } from 'lodash';
import { Emit, Vue } from 'vue-property-decorator';
import { ConsoleFacade } from '../helpers';
import { ArgumentValidator } from '../helpers/argument-validator';

export class EventBusService<T> extends Vue {

    private lastEmitted?: T;

    @Emit('changed')
    // tslint:disable-next-line:no-empty
    private emitChanged(obj: T): T {

        ArgumentValidator.notNullOrEmpty(obj, `obj`);

        return obj;
    }

    public get current(): T | undefined {

        return this.lastEmitted;
    }

    public set(object: T): void {

        if (_.isEqual(this.lastEmitted, object)) {

            ConsoleFacade.log(`EventBusService: No need to emit change event since object not changed.`, this.lastEmitted, object);
            return;
        }

        this.emitChanged(object);

        ConsoleFacade.log(`EventBusService: Change event emitted`, object);

        this.lastEmitted = object;
    }

}